import React, { useState } from 'react';
import { Box, Switch, FormControlLabel, Button } from '@mui/material';
import GanttChartComponent from './GanttChartComponent';
import TimelinePopupComponent from './TimelinePopupComponent';

const ProjectTimeline = ({ projectId }) => {
  const [showGanttChart, setShowGanttChart] = useState(false);

  const handleSwitchChange = (event) => {
    setShowGanttChart(event.target.checked);
  };

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <FormControlLabel
          control={<Switch checked={showGanttChart} onChange={handleSwitchChange} />}
          label="Schedule Chart"
        />
      </Box>
      {showGanttChart ? (
        <GanttChartComponent projectId={projectId} />
      ) : (
        <TimelinePopupComponent projectId={projectId} />
      )}
    </Box>
  );
};

export default ProjectTimeline;